/**
* DevExpress Analytics (analytics-internal.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
require("./undo-engine/_utils");
require("./undo-engine/_legacy");
require("./serializer/_internal");
require("./serializer/_utils");
require("./serializer/_legacy");
require("./property-grid/localization/_localization");
require("./property-grid/localization/_localizationStringIds");
require("./property-grid/widgets/internal/_utils");
require("./property-grid/internal/_codeResolver");
require("./property-grid/_propertiesAccessibilityProvider");
require("./property-grid/internal/_popupService");
require("./property-grid/internal/_addon");
require("./property-grid/_legacy");
require("./widgets/_utils");
require("./widgets/internal/_dxtInherit");
require("./widgets/common/_displayNameProvider");
require("./widgets/_searchHighlighting");
require("./widgets/_legacy");
require("./core/_actionProvider");
require("./core/binding/_requestHelper");
require("./core/binding/_jsDesignerBindingCommon");
require("./core/binding/_jsDesignerBindingCommonOptions");
require("./core/dragDrop/_dragDropHandler");
require("./core/tools/_keyboardHelper");
require("./accessibility/_internal");
require("./accessibility/_controlElementBase");
require("./accessibility/_keyboardHelperBase");
require("./accessibility/_controlElementWithParentHighlight");
require("./accessibility/_keyboardHelperWithArrowButtonBase");
require("./accessibility/_listKeyboardHelper");
require("./accessibility/_toolbarKeyboardHelper");
require("./accessibility/_accordionKeyboardHelper");
require("./accessibility/_treeListKeyboardHelper");
require("./accessibility/_rightPanelKeyboardHelper");
require("./core/_bindings");
require("./core/dragDrop/_dragHelperContent");
require("./core/dragDrop/_selectionDragDropHandler");
require("./core/dragDrop/_toolboxDragDropHandler");
require("./core/internal/dx-versions");
require("./core/internal/_utils");
require("./core/internal/_ajaxSetup");
require("./core/internal/_controlsHelper");
require("./core/internal/_cssCalculator");
require("./core/internal/_editorTypeMapper");
require("./core/internal/_getNameHelpers");
require("./core/internal/_globalize");
require("./core/internal/_hoverInfo");
require("./core/internal/_inlineTextEdit");
require("./core/internal/_objectStructureControllers");
require("./core/internal/_objectStructureProviders");
require("./core/internal/_papperKindMapper");
require("./core/internal/_processError");
require("./core/internal/_resizable");
require("./core/internal/_stores");
require("./core/internal/_surfaceHelpers");
require("./core/internal/_validation");
require("./core/selection/_combinedObj");
require("./core/selection/_selection");
require("./core/selection/_selectionHelpers");
require("./core/snapLines/_snapLinesCollector");
require("./core/snapLines/_snapLinesHelper");
require("./core/snapLines/_snapLineSurface");
require("./core/tools/_actionList");
require("./core/tools/_copyPaste");
require("./core/utils/_arrayutils");
require("./core/utils/_fieldListProvider");
require("./core/utils/_infoMessageHelpers");
require("./core/utils/_units");
require("./core/utils/_utils");
require("./core/utils/_designerInitializer");
require("./core/utils/_visitors");
require("./core/widgets/bordereditor/_binding");
require("./core/widgets/bordereditor/_bordereditor");
require("./core/widgets/propertygrid/_controlProperties");
require("./core/widgets/propertygrid/_group");
require("./core/_metadata");
require("./core/utils/_designerCreator");
require("./core/widgets/_buttonInlineEditor");
require("./core/_legacy");
require("./core/internal/_scrollProcessor");
__export(require("./undo-engine/_utils"));
__export(require("./serializer/_internal"));
__export(require("./serializer/_utils"));
__export(require("./property-grid/localization/_localization"));
__export(require("./property-grid/localization/_localizationStringIds"));
__export(require("./property-grid/widgets/internal/_utils"));
__export(require("./property-grid/internal/_codeResolver"));
__export(require("./property-grid/_propertiesAccessibilityProvider"));
__export(require("./property-grid/internal/_popupService"));
__export(require("./property-grid/internal/_addon"));
__export(require("./widgets/internal/_dxtInherit"));
__export(require("./widgets/_utils"));
__export(require("./widgets/common/_displayNameProvider"));
__export(require("./widgets/_searchHighlighting"));
__export(require("./core/_actionProvider"));
__export(require("./core/binding/_requestHelper"));
__export(require("./core/binding/_jsDesignerBindingCommon"));
__export(require("./core/dragDrop/_dragDropHandler"));
__export(require("./core/tools/_keyboardHelper"));
__export(require("./accessibility/_internal"));
__export(require("./accessibility/_controlElementBase"));
__export(require("./accessibility/_keyboardHelperBase"));
__export(require("./accessibility/_controlElementWithParentHighlight"));
__export(require("./accessibility/_keyboardHelperWithArrowButtonBase"));
__export(require("./accessibility/_listKeyboardHelper"));
__export(require("./accessibility/_toolbarKeyboardHelper"));
__export(require("./accessibility/_accordionKeyboardHelper"));
__export(require("./accessibility/_treeListKeyboardHelper"));
__export(require("./accessibility/_rightPanelKeyboardHelper"));
__export(require("./core/dragDrop/_dragHelperContent"));
__export(require("./core/dragDrop/_selectionDragDropHandler"));
__export(require("./core/dragDrop/_toolboxDragDropHandler"));
__export(require("./core/internal/dx-versions"));
__export(require("./core/internal/_utils"));
__export(require("./core/internal/_ajaxSetup"));
__export(require("./core/internal/_controlsHelper"));
__export(require("./core/internal/_cssCalculator"));
__export(require("./core/internal/_editorTypeMapper"));
__export(require("./core/internal/_getNameHelpers"));
__export(require("./core/internal/_globalize"));
__export(require("./core/internal/_hoverInfo"));
__export(require("./core/internal/_inlineTextEdit"));
__export(require("./core/internal/_objectStructureControllers"));
__export(require("./core/internal/_objectStructureProviders"));
__export(require("./core/internal/_papperKindMapper"));
__export(require("./core/internal/_processError"));
__export(require("./core/internal/_stores"));
__export(require("./core/internal/_surfaceHelpers"));
__export(require("./core/internal/_validation"));
__export(require("./core/selection/_combinedObj"));
__export(require("./core/selection/_selection"));
__export(require("./core/selection/_selectionHelpers"));
__export(require("./core/snapLines/_snapLinesCollector"));
__export(require("./core/snapLines/_snapLinesHelper"));
__export(require("./core/snapLines/_snapLineSurface"));
__export(require("./core/tools/_actionList"));
__export(require("./core/tools/_copyPaste"));
__export(require("./core/utils/_arrayutils"));
__export(require("./core/utils/_fieldListProvider"));
__export(require("./core/utils/_infoMessageHelpers"));
__export(require("./core/utils/_units"));
__export(require("./core/utils/_utils"));
__export(require("./core/utils/_designerInitializer"));
__export(require("./core/utils/_visitors"));
__export(require("./core/widgets/bordereditor/_bordereditor"));
__export(require("./core/widgets/propertygrid/_controlProperties"));
__export(require("./core/widgets/propertygrid/_group"));
__export(require("./core/_metadata"));
__export(require("./core/utils/_designerCreator"));
__export(require("./core/widgets/_buttonInlineEditor"));
__export(require("./core/internal/_scrollProcessor"));
